import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Landmark } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ResumenBancos from "@/components/bancos/ResumenBancos";
import MovimientosBanco from "@/components/bancos/MovimientosBanco";
import CuentasBancarias from "@/components/bancos/CuentasBancarias";
import Inversionistas from "@/components/bancos/Inversionistas";
import ManualContable from "@/components/bancos/ManualContable";
import ReporteAnual from "@/components/bancos/ReporteAnual";
import { invalidarCuentas } from "@/components/bancos/CuentaBancariaSelect";

const TABS = [["resumen", "Balance"], ["movimientos", "Movimientos"], ["anual", "Año completo"], ["inversionistas", "Proyecto Inversionistas"], ["cuentas", "Cuentas"], ["manual", "Manual contable"]];

export default function Bancos() {
  const { user } = useAuth();
  const esAdmin = user?.rol === "gran_admin";
  const [tab, setTab] = useState("resumen");
  const [r, setR] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [catalogos, setCatalogos] = useState(null);
  const [proyectos, setProyectos] = useState([]);
  const [inversionistas, setInversionistas] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const cargar = useCallback(async () => {
    try {
      invalidarCuentas();
      const [res, cts, cat, pr, inv] = await Promise.all([api.get("/bancos/resumen"), api.get("/bancos/cuentas?incluir_inactivas=true"), api.get("/bancos/catalogos"), api.get("/bancos/proyectos"), api.get("/bancos/inversionistas")]);
      setR(res.data); setCuentas(cts.data); setCatalogos(cat.data); setProyectos(pr.data); setInversionistas(inv.data);
    } catch (e) { toast.error(formatApiError(e)); }
  }, []);
  useEffect(() => { cargar(); api.get("/sucursales").then((x) => setSucursales(x.data)).catch(() => {}); }, [cargar]);
  const activas = cuentas.filter((c) => c.activa !== false);
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1500px] mx-auto animate-fade-up" data-testid="bancos-page">
      <div className="mb-5"><div className="eyebrow mb-1">Finanzas · Bancos</div><h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-brand-ink flex items-center gap-2"><Landmark className="w-7 h-7 text-brand-amber" /> Bancos y gestión contable</h1><p className="text-sm text-brand-muted mt-1">Las 3 cuentas de la empresa, su libro de movimientos por unidad de negocio (Sucursales · CEDIS Oaxaca · Franquicias · Proyecto Inversionistas · Corporativo), conciliación con el estado de cuenta y balance consolidado.</p></div>
      <div className="flex flex-wrap gap-1 mb-4" data-testid="bancos-tabs">{TABS.map(([k, l]) => <button key={k} data-testid={`bancos-tab-${k}`} onClick={() => setTab(k)} className={`h-9 px-4 rounded-full text-sm font-bold ${tab === k ? "bg-brand-ink text-white" : "bg-brand-surface text-brand-slate"}`}>{l}</button>)}</div>
      {tab === "resumen" && <ResumenBancos r={r} />}
      {tab === "movimientos" && <MovimientosBanco cuentas={activas} catalogos={catalogos} proyectos={proyectos} inversionistas={inversionistas} sucursales={sucursales} esAdmin={esAdmin} onCambio={cargar} />}
      {tab === "anual" && <ReporteAnual />}
      {tab === "inversionistas" && <Inversionistas inversionistas={inversionistas} proyectos={proyectos} sucursales={sucursales} cuentas={activas} onCambio={cargar} />}
      {tab === "cuentas" && <CuentasBancarias cuentas={cuentas} esAdmin={esAdmin} onCambio={cargar} />}
      {tab === "manual" && <ManualContable />}
    </div>
  );
}
